import { gql } from '@apollo/client';

export interface ILibraryCategoryFoodBeverage {
  name: string;
  sys: { id: string };
}

export const LibraryCategoryFoodBeverageFragment = gql`
  fragment LibraryCategoryFoodBeverage on LibraryCategoryFoodBeverage {
    name
    sys {
      id
    }
  }
`;
